import { render, staticRenderFns } from "./ProductBrandItem.vue?vue&type=template&id=331abeb9"
import script from "./ProductBrandItem.vue?vue&type=script&lang=js"
export * from "./ProductBrandItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports